import React, { useEffect, useState } from "react";
import useAxios from "../utils/useAxios";
import {
  FaUserPlus,
  FaSearch,
  FaEnvelope,
  FaPhone,
  FaBriefcase,
  FaUserTie,
  FaTimes,
  FaEye,
  FaEdit,
  FaTrash,
  FaUserShield
} from "react-icons/fa";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";

import { urlimage } from '../utils/config';
import { useSidebar } from '../context/SidebarContext';
import OrganisationSelector from '../components/OrganisationSelector';
import styles from '../styles/EmployeesPage';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom'; 

const EmployeesPage = () => {
  const [organisations, setOrganisations] = useState([]);
  const [selectedOrganisation, setSelectedOrganisation] = useState(null);
  const [currentOrganisation, setCurrentOrganisation] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const { sidebarVisible } = useSidebar();
  const { user } = useAuth();
  const navigate = useNavigate(); 
  const [formData, setFormData] = useState({
    username: "",
    first_name: "",
    last_name: "",
    email: "",
    telephone: "",
    poste: "",
    image: null,
    password: "",
    password2: "",
    matricule: "",
    organisation: ""
  });

  const [formDataEdit, setFormDataEdit] = useState({
    username: "",
    first_name: "",
    last_name: "",
    email: "",
    telephone: "",
    poste: "",
    image: null,
    matricule: "",
    organisation: ""
  });

  const api = useAxios();

  // Charger les organisations
  useEffect(() => {
    const fetchOrganisations = async () => {
      try {
        const res = await api.get('/organisations/');
        setOrganisations(res.data);
      } catch (error) {
        Swal.fire('Erreur', 'Impossible de charger les organisations', 'error');
      }
    };
    fetchOrganisations();
  }, []);

  
  const handleOrganisationChange = (orgId, org) => {
    setSelectedOrganisation(orgId);
    setCurrentOrganisation(org);
  };

  
  useEffect(() => {
    if (selectedOrganisation) {
      fetchEmployees();
    }
  }, [selectedOrganisation]);

  const fetchEmployees = async () => {
    try {
      const response = await api.get(`/employes/?organisation=${selectedOrganisation}`);
      setEmployees(response.data);
    } catch (error) {
      console.error("Erreur API:", error);
      setError("Impossible de récupérer les employés.");
    }
  };

  const filteredEmployees = employees.filter((emp) =>
    `${emp.last_name} ${emp.first_name}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const handleChange = (e) => {
    if (e.target.name === "image") {
      setFormData({ ...formData, image: e.target.files[0] });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleEditChange = (e) => {
    if (e.target.name === "image") {
      setFormDataEdit({ ...formDataEdit, image: e.target.files[0] });
    } else {
      setFormDataEdit({ ...formDataEdit, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedOrganisation) {
      Swal.fire('Erreur', 'Veuillez sélectionner une organisation', 'error');
      return;
    }
    
    const formDataToSend = new FormData();
    for (const key in formData) {
      if (key === "image" && formData[key]) {
        formDataToSend.append(key, formData[key]);
      } else if (key !== "image") {
        formDataToSend.append(key, formData[key]);
      }
    }
    formDataToSend.append("organisation", selectedOrganisation);

    try {
      const response = await api.post("/employes/add/", formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data && response.data.employe) {
        setEmployees((prev) => [...prev, response.data.employe]);
        setShowModal(false);
        Swal.fire({
          title: "Employé ajouté avec succès",
          icon: "success",
          toast: true,
          timer: 6000,
          position: "top-right",
          timerProgressBar: true,
          showConfirmButton: false,
        });
      } else {
        throw new Error("Données invalides reçues de l'API.");
      }
    } catch (error) {
      console.error("Erreur lors de l'ajout:", error);
      Swal.fire({
        title: "Échec de l'ajout",
        icon: "error",
        toast: true,
        timer: 6000,
        position: "top-right",
        timerProgressBar: true,
        showConfirmButton: false,
      });
    }
  };

  const handleView = (employee) => {
    setSelectedEmployee(employee);
    setShowViewModal(true);
  };

  const handleEdit = (employee) => {
    setFormDataEdit({
      username: employee.username,
      first_name: employee.first_name,
      last_name: employee.last_name,
      email: employee.email,
      telephone: employee.telephone,
      poste: employee.poste,
     
      matricule: employee.matricule,
      image: employee.image ? `${urlimage}${employee.image}` : null,
      organisation: employee.organisation
    });
    setSelectedEmployee(employee);
    setShowEditModal(true);
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
  
    if (!formDataEdit.username || !formDataEdit.email || !formDataEdit.first_name || !formDataEdit.last_name) {
      Swal.fire({
        title: "Erreur",
        text: "Tous les champs obligatoires doivent être remplis.",
        icon: "error",
        toast: true,
        timer: 6000,
        position: "top-right",
        timerProgressBar: true,
        showConfirmButton: false,
      });
      return;
    }
  
    const formDataToSend = new FormData();
  
    for (const key in formDataEdit) {
      if (key === "image") {
        if (formDataEdit.image && typeof formDataEdit.image !== "string") {
          formDataToSend.append("image", formDataEdit.image);
        }
      } else if (key === "remove_image" && formDataEdit[key]) {
        formDataToSend.append("remove_image", "true");
      } else {
        formDataToSend.append(key, formDataEdit[key]);
      }
    }
  
    try {
      const response = await api.put(
        `/employes/${selectedEmployee.username}/update/`,
        formDataToSend,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
  
      if (response.data) {
        setEmployees((prev) =>
          prev.map((emp) =>
            emp.id === response.data.id ? response.data : emp
          )
        );
        setShowEditModal(false);
  
        Swal.fire({
          title: "Employé modifié avec succès",
          icon: "success",
          toast: true,
          timer: 6000,
          position: "top-right",
          timerProgressBar: true,
          showConfirmButton: false,
        });
      } else {
        throw new Error("Données invalides reçues de l'API.");
      }
    } catch (error) {
      console.error("Erreur lors de la modification:", error);
      Swal.fire({
        title: "Échec de la modification",
        icon: "error",
        toast: true,
        timer: 6000,
        position: "top-right",
        timerProgressBar: true,
        showConfirmButton: false,
      });
    }
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Supprimer cet employé ?",
      text: "Cette action est irréversible.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonText: 'Annuler',

      confirmButtonText: "Oui, supprimer",
    });

    if (confirm.isConfirmed) {
      try {
        await api.delete(`/employes/${id}/delete/`);
        setEmployees((prev) => prev.filter((emp) => emp.id !== id));
        Swal.fire("Supprimé !", "L'employé a été supprimé.", "success");
      } catch (error) {
        console.error("Erreur suppression:", error);
        Swal.fire("Erreur", "Impossible de supprimer l'employé.", "error");
      }
    }
  };

  const generatePDF = () => {
    const doc = new jsPDF();
  
    const logo = "/logo.png"; 
    doc.addImage(logo, "JPEG", 10, 10, 25, 25); 
    
    doc.setFontSize(18);
    doc.setTextColor(30, 60, 114); 
    
    doc.setDrawColor(150);
    doc.line(10, 40, 200, 40);
  
    const imgSrc = selectedEmployee.image
      ? `${urlimage}${selectedEmployee.image}` 
      : "/default.jpg";
    doc.addImage(imgSrc, "JPEG", 20, 45, 40, 40);
  
    const qrSrc = `${urlimage}${selectedEmployee.qr_code}`;
    doc.addImage(qrSrc, "JPEG", 150, 45, 40, 40);
  
    doc.setDrawColor(200); 
    doc.roundedRect(15, 90, 180, 90, 5, 5); 
  
    doc.setFontSize(12);
    doc.setTextColor(0);
  
    const infoStartY = 100;
    const lineHeight = 10;
  
    const infos = [
      ["Nom", `${selectedEmployee.last_name} ${selectedEmployee.first_name}`],
      ["Email", selectedEmployee.email],
      ["Téléphone", selectedEmployee.telephone || "Non renseigné"],
      ["Poste", selectedEmployee.poste],
      ["Rôle", selectedEmployee.role],
      ["Matricule", selectedEmployee.matricule]
    ];
  
    infos.forEach(([label, value], index) => {
      const y = infoStartY + index * lineHeight;
      doc.setFont(undefined, "bold");
      doc.text(`${label} :`, 25, y);
      doc.setFont(undefined, "normal");
      doc.text(value, 60, y);
    });
  
    const currentDate = new Date().toLocaleDateString();
    doc.setFontSize(10);
    doc.setTextColor(100);
    doc.text(`Généré le ${currentDate}`, 105, 285, { align: "center" });
  
    doc.save(`${selectedEmployee.first_name}_${selectedEmployee.last_name}_details.pdf`);
  };

  return (
    <div style={{...styles.container, marginLeft: sidebarVisible ? 250 : 0}}>
      
      {/* Header avec sélecteur d'organisation */}
      <div style={styles.organisationHeader}>
        <OrganisationSelector 
          onOrganisationChange={handleOrganisationChange}
          selectedOrganisation={selectedOrganisation}
        />

        {currentOrganisation && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ color: '#666', fontSize: '14px' }}>
              Gestion des employés pour cette organisation
            </span>
          </div>
        )}
      </div>

      {currentOrganisation ? (
        <>
          <h1 style={styles.pageTitle}>
            📋 EMPLOYÉS - {currentOrganisation.nom}
          </h1>

          {(user?.is_super_admin || user?.permissions?.includes("CREATE_ROLE")) && (
          <div className="mb-4 d-flex justify-content-end gap-2">
            <button
              style={styles.navButton}
              onClick={() => navigate('/role')}
            >
              <FaUserShield /> Gestion des rôles
            </button>

          </div>
          )}


          <div style={styles.actionBar}>
            {(user?.is_super_admin || user?.permissions?.includes("CREATE_EMPLOYE")) && (
            <button
              onClick={() => setShowModal(true)}
              style={styles.addButton}
            >
              <FaUserPlus style={{ marginRight: "8px" }} /> Ajouter
            </button>




            )}
            <div style={styles.searchContainer}>
              <FaSearch style={{ marginRight: "8px", color: "#1B019B" }} />
              <input
                type="text"
                placeholder="Rechercher un employé..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={styles.searchInput}
              />
            </div>

            <span style={styles.employeeCount}>
              {employees.length} employés
            </span>
          </div>

          {error ? (
            <p style={{ color: "red" }}>{error}</p>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table style={styles.table}>
                <thead style={styles.tableHeader}>
                  <tr>
                    <th>Photo</th>
                    <th>Nom Complet</th>
                    <th><FaEnvelope /> Email</th>
                    <th><FaPhone /> Téléphone</th>
                    <th><FaBriefcase /> Poste</th>
                    <th><FaUserTie /> Rôle</th>
                    <th>Actions</th> 
                  </tr>
                </thead>
                <tbody>
                  {filteredEmployees.length > 0 ? (
                    filteredEmployees.map((emp) => (
                      <tr key={emp.id}>
                        <td>
                          <img
                            src={emp.image ? `${urlimage}${emp.image}` : "/default.jpg"}
                            alt="Profil"
                            style={styles.employeeImage}
                          />
                        </td>
                        <td>{`${emp.last_name} ${emp.first_name}`}</td>
                        <td>{emp.email}</td>
                        <td>{emp.telephone || "Non renseigné"}</td>
                        <td>{emp.poste || "Non renseigné"}</td>
                        <td>{emp.role ? emp.role : "Pas de rôle"}</td>
                        <td style={styles.actionButtons}>
                          {(user?.is_super_admin || user?.permissions?.includes("VIEW_EMPLOYE")) && (
                          <button
                            style={styles.viewButton}
                            title="Voir"
                            onClick={() => handleView(emp)}
                          >
                            <FaEye />
                          </button>
                          )}
                          {(user?.is_super_admin || user?.permissions?.includes("UPDATE_EMPLOYE")) && (
                          <button
                            style={styles.editButton}
                            title="Modifier"
                            onClick={() => handleEdit(emp)}
                          >
                            <FaEdit />
                          </button>
                          )}
                          {(user?.is_super_admin ||
                            user?.permissions?.includes("VIEW_PERMISSIONS") || user?.permissions?.includes("UPDATE_ROLE") || user?.permissions?.includes("VIEW_ROLE")) && (
                                      <button
                                        style={styles.permissionsButton}
                                        title="Attribuer un rôle"
                                        onClick={() => window.location.href = `/employes/${emp.id}/role`}
                                      >
                                        <FaUserShield />
                                      </button>  
                          )}

                          {(user?.is_super_admin || user?.permissions?.includes("DELETE_EMPLOYE")) && (                      
                          <button
                            style={styles.deleteButton}
                            title="Supprimer"
                            onClick={() => handleDelete(emp.id)}
                          >
                            <FaTrash />
                          </button>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" style={styles.noData}>
                        Aucun employé trouvé pour cette organisation.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

          {showModal && (
            <div style={styles.modalOverlay}>
              <div style={styles.modalContent}>
                <button onClick={() => setShowModal(false)} style={styles.closeButton}>
                  <FaTimes />
                </button>
                <h2 style={styles.modalTitle}>
                  Ajouter un Employé - {currentOrganisation.nom}
                </h2>
                <form onSubmit={handleSubmit}>
                  <div style={styles.formRow}>
                    <div style={styles.formGroup}>
                      <label htmlFor="username" style={styles.label}>Nom d'utilisateur</label>
                      <input type="text" name="username" value={formData.username} onChange={handleChange} required style={styles.input} />
                    </div>
                    <div style={styles.formGroup}>
                      <label htmlFor="first_name" style={styles.label}>Prénom</label>
                      <input type="text" name="first_name" value={formData.first_name} onChange={handleChange} required style={styles.input} />
                    </div>
                  </div>

                  <div style={styles.formRow}>
                    <div style={styles.formGroup}>
                      <label htmlFor="last_name" style={styles.label}>Nom</label>
                      <input type="text" name="last_name" value={formData.last_name} onChange={handleChange} required style={styles.input} />
                    </div>
                    <div style={styles.formGroup}>
                      <label htmlFor="email" style={styles.label}>Email</label>
                      <input type="email" name="email" value={formData.email} onChange={handleChange} required style={styles.input} />
                    </div>
                  </div>

                  <div style={styles.formRow}>
                    <div style={styles.formGroup}>
                      <label htmlFor="matricule" style={styles.label}>Matricule</label>
                      <input type="text" name="matricule" value={formData.matricule} onChange={handleChange} required style={styles.input} />
                    </div>
                    <div style={styles.formGroup}>
                      <label htmlFor="telephone" style={styles.label}>Téléphone</label>
                      <input type="text" name="telephone" value={formData.telephone} onChange={handleChange} style={styles.input} />
                    </div>
                  </div>

                  <div style={styles.formRow}>
                    <div style={styles.formGroup}>
                      <label htmlFor="poste" style={styles.label}>Poste</label>
                      <input type="text" name="poste" value={formData.poste} onChange={handleChange} required style={styles.input} />
                    </div>
                    <div style={styles.formGroup}>
                      <label htmlFor="password" style={styles.label}>Mot de passe</label>
                      <input type="password" name="password" value={formData.password} onChange={handleChange} required style={styles.input} />
                    </div>
                  </div>

                  <div style={styles.formRow}>
                    <div style={styles.formGroup}>
                      <label htmlFor="password2" style={styles.label}>Confirmer le mot de passe</label>
                      <input type="password" name="password2" value={formData.password2} onChange={handleChange} required style={styles.input} />
                    </div>

                 
                    <div style={styles.formGroup}>
                      <label htmlFor="image" style={styles.label}>Image</label>
                      <input type="file" name="image" onChange={handleChange} style={styles.input} />
                    </div>
                    <div style={styles.formGroup}></div>
                  </div>

                  <div style={styles.formSubmit}>
                     
                    <button type="submit" style={styles.submitButton}>
                      Ajouter l'employé
                    </button>
                    
                  </div>
                </form>
              </div>
            </div>
          )}

          {showViewModal && selectedEmployee && (
            <div style={styles.modalOverlay}>
              <div style={styles.viewModalContent}>
                <button onClick={() => setShowViewModal(false)} style={styles.closeButton}>
                  <FaTimes />
                </button>
                <h2 style={styles.modalTitle}>
                  Détails de l'employé
                </h2>
                <div style={styles.employeeImageContainer}>
                  <img
                    src={selectedEmployee.image ? `${urlimage}${selectedEmployee.image}` : "/default.jpg"}
                    alt="Profil"
                    style={styles.largeEmployeeImage}
                  />
                </div>
                <p><strong>Nom :</strong> {selectedEmployee.last_name} {selectedEmployee.first_name}</p>
                <p><strong>Email :</strong> {selectedEmployee.email}</p>
                <p><strong>Téléphone :</strong> {selectedEmployee.telephone || "Non renseigné"}</p>
                <p><strong>Matricule :</strong> {selectedEmployee.matricule}</p>
                <p><strong>Poste :</strong> {selectedEmployee.poste}</p>
                <p><strong>Rôle :</strong> {selectedEmployee.role ? selectedEmployee.role : "Pas de rôle"}</p>
                <div style={styles.qrCodeContainer}>
                  <img
                    src={selectedEmployee.qr_code ? `${urlimage}${selectedEmployee.qr_code}` : "/default-qr.jpg"}
                    alt="QR Code"
                    style={styles.qrCode}
                  />
                </div>
                <button
                  onClick={generatePDF}
                  style={styles.pdfButton}
                >
                  Télécharger en PDF
                </button>
              </div>
            </div>
          )}

          {showEditModal && (
            <div style={styles.modalOverlay}>
              <div style={styles.modalContent}>
                <button onClick={() => setShowEditModal(false)} style={styles.closeButton}>
                  <FaTimes />
                </button>

                <h2 style={styles.modalTitle}>
                  Modifier l'employé
                </h2>

                <form onSubmit={handleEditSubmit}>
                  <div style={styles.formRow}>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Prénom</label>
                      <input type="text" name="first_name" value={formDataEdit.first_name} onChange={handleEditChange} style={styles.input} />
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Nom</label>
                      <input type="text" name="last_name" value={formDataEdit.last_name} onChange={handleEditChange} style={styles.input} />
                    </div>
                  </div>

                  <div style={styles.formRow}>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Email</label>
                      <input type="email" name="email" value={formDataEdit.email} onChange={handleEditChange} style={styles.input} />
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Téléphone</label>
                      <input type="text" name="telephone" value={formDataEdit.telephone} onChange={handleEditChange} style={styles.input} />
                    </div>
                  </div>

                  <div style={styles.formRow}>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Nom d'utilisateur</label>
                      <input type="text" name="username" value={formDataEdit.username} onChange={handleEditChange} style={styles.input} />
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Matricule</label>
                      <input type="text" name="matricule" value={formDataEdit.matricule} onChange={handleEditChange} style={styles.input} />
                    </div>
                  </div>

                  <div style={styles.formRow}>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Poste</label>
                      <input type="text" name="poste" value={formDataEdit.poste} onChange={handleEditChange} style={styles.input} />
                    </div>
    
                  </div>

                  <div style={styles.formRow}>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Image</label>
                      <input type="file" name="image" onChange={handleEditChange} style={styles.input} />
                      {formDataEdit.image && (
                        <div style={styles.imagePreviewContainer}>
                          <img
                            src={typeof formDataEdit.image === "string"
                              ? formDataEdit.image
                              : URL.createObjectURL(formDataEdit.image)}
                            alt="Aperçu"
                            style={styles.imagePreview}
                          />
                          <button
                            type="button"
                            onClick={() => setFormDataEdit({ ...formDataEdit, image: null, remove_image: true })}
                            style={styles.removeImageButton}
                            title="Supprimer l'image"
                          >
                            &times;
                          </button>
                        </div>
                      )}
                    </div>
                  </div>

                  <div style={styles.formSubmit}>
                    <button type="submit" style={styles.submitButton}>
                      Modifier l'employé
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </>
      ) : (
        <div style={styles.noOrganisation}>
          <h4 style={{ color: '#666', marginBottom: '10px' }}>Aucune organisation sélectionnée</h4>
          <p style={{ color: '#999' }}>Veuillez sélectionner une organisation pour gérer ses employés</p>
        </div>
      )}
    </div>
  );
};

export default EmployeesPage;